import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandX,
} from "@tabler/icons-react";

const navigation = {
  social: [
    { name: "Facebook", href: "#", icon: IconBrandFacebook },
    { name: "Instagram", href: "#", icon: IconBrandInstagram },
    { name: "X", href: "#", icon: IconBrandX },
  ],
  legal: [
    { name: "Terms of Service", href: "/terms" },
    { name: "Privacy Policy", href: "/policys" },
    { name: "Contact Us", href: "/contact" },
  ],
};

export default function Footer() {
  return (
    <footer
      className="bg-white text-black"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="py-6 border-t border-black/50 pt-8 md:flex md:items-center md:justify-between">
          <div className="md:mt-0 md:order-1">
            <p className="text-base text-black/80">
              &copy; 2025 Histori.ai, all rights reserved.
            </p>
            <div className="flex space-x-4">
              {navigation.legal.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-black/70 hover:text-black transition-colors"
                >
                  {item.name}
                </a>
              ))}
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-black/70 hover:text-black transition-colors"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
